import ProjectGridSection from '../../../components/common/ProjectGridSection'
import { ProjectSelectionType } from '../../../types/index'



export default function ProjectSelection(props: ProjectSelectionType) {
    return <ProjectGridSection heading={props.heading} projects={props.projects} showPortfolioCta />
}
